import MessageCardGroupNativeButtons from 'components/LandingPage/MessageCardGroup/MessageCardGroupNativeButtons/MessageCardGroupNativeButtons';
import useIsAppleDevice from 'hooks/useIsAppleDevice';
import React, { FC } from 'react';
import { ButtonNativeApp } from 'store/landing/types';
import styles from './DownloadAppMobile.module.scss';

export interface DownloadAppMobileProps {
  h1: string;
  buttonNativeApp?: ButtonNativeApp;
  phoneImageUrl: string;
  phoneAndroidImageUrl: string;
}

const DownloadAppMobile: FC<DownloadAppMobileProps> = ({
  h1: __html,
  buttonNativeApp,
  phoneImageUrl,
  phoneAndroidImageUrl,
}) => {
  const isAppleDevice = useIsAppleDevice();

  return (
    <div className={styles.container}>
      <div className={styles.contentBlock}>
        <div className={styles.details}>
          <h3 dangerouslySetInnerHTML={{ __html }} />
          <p>Click the icon below to download the app</p>
          {buttonNativeApp && <MessageCardGroupNativeButtons buttonNativeApp={buttonNativeApp} />}
        </div>
        <p className={styles.devider}>-</p>
        <div className={styles.image}>
          <div style={{ backgroundImage: `url(${isAppleDevice ? phoneImageUrl : phoneAndroidImageUrl})` }} />
        </div>
      </div>
    </div>
  );
};

export default DownloadAppMobile;
